import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const roleCopy = {
  Care: "A treatment step, considered with intention.",
  Protect: "Daily protection, thoughtfully formulated.",
  Cleanse: "A gentle first step to your ritual.",
};

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${index * 110}ms` }}
    >
      <div className="relative overflow-hidden bg-linen aspect-[4/5]">
        <img
          src={product.image}
          alt={product.attribution}
          loading="lazy"
          className={`w-full h-full transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05] ${
            product.image_placeholder ? "object-contain p-10 mix-blend-multiply" : "object-cover"
          }`}
        />
        <span className="absolute top-5 left-5 numeral">0{index + 1}</span>
        {product.image_placeholder && (
          <span className="absolute top-5 right-5 text-[10px] uppercase tracking-[0.2em] text-forest/50">
            Placeholder
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out bg-forest text-ivory px-6 py-4 flex items-center justify-between text-[11px] uppercase tracking-[0.22em]">
          Explore the ritual <ArrowRight size={14} />
        </div>
      </div>
      <div className="mt-6 flex items-baseline justify-between gap-4 border-b border-forest/15 pb-5">
        <h3 className="font-serif text-3xl text-forest">{product.name}</h3>
        <p className="text-[11px] uppercase tracking-[0.24em] text-champagne">{product.routine_role}</p>
      </div>
      <p className="mt-4 text-sm text-charcoal/65 leading-relaxed font-light">
        {roleCopy[product.routine_role]}
      </p>
    </Link>
  );
}
